<div class="notification">
    <p>{{message}}</p>
    <p>{{messageOne}}</p>
</div>

<div class="mb-5 okayBtn" [ngClass]="isArabic ? 'arabicOkay' : ''">
    <button type="submit" class="btn btn-primary" [ngClass]="cancelButton ? (isArabic ? 'marginRightBtn rightArabicBtn' : 'marginRightBtn') : (isArabic ? 'rightArabicBtn' : '')"
    (click)="closeNotification(true)">
        <span *ngIf="!isArabic">OK</span>
        <span *ngIf="isArabic">نعم</span>
    </button>
    <button type="submit" class="btn btn-primary cancelBtn" (click)="closeNotification()" *ngIf="cancelButton">
        <span *ngIf="!isArabic">CANCEL</span>
        <span *ngIf="isArabic">إلغاء</span>
    </button>
</div>
